import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { firstValueFrom } from 'rxjs';
import { ApiCore } from 'src/app/config/api';
import { ApiService } from 'src/app/core/http/api.service';
import { IThemeConfig, Theme, ThemeResponse } from './interfaces/theme-config.interface';
import { SessionService } from 'src/app/core/auth/session.service';


@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: any;
  private url: string = ApiCore.BASE_URL;

  constructor(private readonly sessionService: SessionService,private httpClient: HttpClient) {}

  // loadConfig():void {
  //   this.apiService.get('/api/config')
  //   .subscribe({
  //     next: (config)=>{
  //       this.config = config;
  //       this.applyTheme(config.theme);
  //     },
  //     error:(err)=>{
  //       console.error('Error al cargar la configuración');
  //     }
  //   })
  // }
  async loadConfig(): Promise<void> {
    const fullUrl = `${this.url}${ApiCore.OPERATOR}/theme-config`
    const promise$ = this.httpClient
    .get<ThemeResponse>(fullUrl);
    return firstValueFrom(promise$).then((config: ThemeResponse) => {
      this.config = config;
      console.log({config});
      this.applyThemes(config);
    })
    .catch(() => {
      console.error('Error al cargar la configuración');
    });
  }
  applyThemes(themes: ThemeResponse){
    this.setPrimaryTheme(themes.primaryTheme);
    this.setSecondaryTheme(themes.secondaryTheme);
  }
  setPrimaryTheme(theme: Theme ){
    const name = theme?.name ? theme.name : 'tema_verde';
    this.sessionService.setItem('primary-theme', name)
    const link = document.getElementById('primary-theme') as HTMLLinkElement;
    if (link) {
      link.href = `assets/css/themes/${name}/style_custom.css`;
      console.log('primary-theme',`assets/css/themes/${name}/style_custom.css`)
    }
    
  }
  setSecondaryTheme(theme: Theme){
    const name = theme?.name ? theme.name : 'tema_purpura';
    this.sessionService.setItem('secondary-theme', name)
    
    const link = document.getElementById('secondary-theme') as HTMLLinkElement;
    if (link) {
      link.href = `assets/css/themes/${name}/style_bg.css`;
      console.log('secondary-theme',`assets/css/themes/${name}/style_bg.css`)
    }
  }
  
  
  // applyTheme(themeConfig: IThemeConfig) {
  //   // console.log('THEME----------------------------------------------------------------');
  //   // console.log({theme: themeConfig});
    
  //   themeConfig.files.forEach(file=>{
  //     const link = document.createElement('link');
  //     link.rel = 'stylesheet';
  //     link.href = `assets/themes/${themeConfig.theme}/${file.path}`;
  //     link.id = file.id;
  //     document.head.appendChild(link);
  //   })
  //   const tailwind = document.createElement('link');
  //   tailwind.rel = 'stylesheet';
  //   tailwind.href = 'https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css';
  //   tailwind.id = 'tailwind-css';
  //   // Eliminar si ya existe (para evitar duplicados)
  //   const existingTailwind = document.getElementById('tailwind-css');
  //   if (existingTailwind) {
  //     document.head.removeChild(existingTailwind);
  //   }
  //   document.head.appendChild(tailwind);
  //   // const link = document.createElement('link');
  //   // link.rel = 'stylesheet';
  //   // link.href = `assets/themes/${theme}/styles.css`;
  //   // link.id = 'general-css';
    
  //   // const link2 = document.createElement('link');
  //   // link2.rel = 'stylesheet';
  //   // link2.href = `assets/themes/${theme}/layout-dark.css`;
  //   // link2.id = 'theme-css';
  //   // const link3 = document.createElement('link');
  //   // link3.rel = 'stylesheet';
  //   // link3.href = `assets/themes/${theme}/styles.general.css`;
  //   // link3.id = 'layout-css';
  //   // const link4 = document.createElement('link');
  //   // link4.rel = 'stylesheet';
  //   // link4.href = `assets/themes/${theme}/theme-dark.css`;
  //   // link4.id = 'layout-css';
  //   // document.head.appendChild(link4);
  //   // document.head.appendChild(link2);
  //   // document.head.appendChild(link3);
  //   // document.head.appendChild(link);
  // }

  getConfig() {
    return this.config;
  }
}
